import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../hooks/usePageTitle';
import './AboutPage.css';

const AboutPage: React.FC = () => {
  const { t } = useTranslation();
  usePageTitle('About Us - Our Mission & Team');

  const principles = t('about.principles.items', { returnObjects: true }) as string[];

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <span className="section-label">{t('about.label')}</span>
          <h1>{t('about.title')}</h1>
          <p className="about-subtitle">
            {t('about.subtitle')}
          </p>
        </div>
      </section>

      <section className="about-story section">
        <div className="container">
          <div className="story-content">
            <div className="story-stats">
              <div className="stat">
                <span className="stat-value">$2B+</span>
                <span className="stat-label">{t('about.stats.exposure')}</span>
              </div>
              <div className="stat">
                <span className="stat-value">First</span>
                <span className="stat-label">{t('about.stats.engine')}</span>
              </div>
            </div>
            <div className="story-text">
              <h2>{t('about.story.title')}</h2>
              <p>{t('about.story.description')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="vision section">
        <div className="container">
          <div className="vision-content">
            <h2>{t('about.vision.title')}</h2>
            <p className="vision-statement">
              {t('about.vision.description')}
            </p>
          </div>
        </div>
      </section>

      <section className="principles section">
        <div className="container">
          <div className="section-header">
            <h2>{t('about.principles.title')}</h2>
          </div>
          <div className="principles-list">
            {principles.map((principle, index) => (
              <div key={index} className="principle-item">
                {principle}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-cta section">
        <div className="container">
          <div className="cta-content">
            <Link to="/contact?type=docs" className="btn btn-primary">{t('common.requestDocumentation')}</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
